const approachSteps = [
  {
    step: "01",
    title: "Clean Architecture",
    description: "Every system begins with a well-defined architectural foundation. Separation of concerns, modular boundaries, and clear dependency rules guide the design from the outset, creating codebases that are easy to reason about and straightforward to evolve.",
  },
  {
    step: "02",
    title: "Performance First",
    description: "Performance is not an afterthought — it is embedded into the development process. From efficient data structures and algorithms to smooth rendering and responsive interactions, every decision is made with performance in mind.",
  },
  {
    step: "03",
    title: "Continuous Refinement",
    description: "Development workflows, tooling, and internal processes are regularly evaluated and improved. The team adopts up-to-date engineering standards and explores emerging technologies to ensure that every project benefits from the latest advancements.",
  },
  {
    step: "04",
    title: "Quality Assurance",
    description: "Rigorous testing, code review practices, and documentation standards form the backbone of the quality assurance process. Every deliverable is validated for correctness, stability, and maintainability before it reaches production.",
  },
];

export default function ApproachSection() {
  return (
    <section className="relative w-full py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="mb-16">
          <p className="text-sm tracking-[0.25em] uppercase text-accent-600 font-label font-medium mb-4">How We Work</p>
          <h2 className="font-heading text-3xl md:text-4xl font-medium text-foreground-900">
            Engineering Approach
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14">
          {approachSteps.map((item) => (
            <div key={item.step} className="flex gap-6">
              <span className="font-heading text-5xl md:text-6xl font-semibold text-accent-200 leading-none flex-shrink-0">
                {item.step}
              </span>
              <div>
                <h3 className="font-heading text-xl font-medium text-foreground-900 mb-3">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed font-light">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}